<script setup>
defineProps({
  question: {
    type: Object,
    required: true,
  },
  faqType: {
    type: String,
    required: false,
    default: 'all',
  },
  faqCategory: {
    type: String,
    required: false,
    default: 'all',
  },
})

const open = ref(false)
</script>

<template>
  <div class="flex flex-col py-4">
    <div
      class="flex cursor-pointer flex-row items-center justify-between"
      @click="open = !open"
    >
      <div class="text-xl font-bold">
        {{ question.question }}
      </div>
      <img
        class="transform duration-200"
        :class="{ 'rotate-180': open }"
        src="~/assets/images/icons/chevron-down-dark.svg"
        alt="Chevron"
      >
    </div>
    <transition name="height">
      <div
        v-if="open"
        class="relative z-40 mt-6"
      >
        <div class="z-30 flex transform flex-row gap-4">
          <div class="flex justify-center ">
            <div class="bg-secondary h-12 w-12 rounded-full opacity-10" />
            <div class="absolute flex opacity-100">
              <img
                class="mt-1"
                src="~/assets/images/product/gino_head.svg"
                alt=""
              >
            </div>
          </div>
          <div class="z-50 flex flex-col gap-4">
            <div
              class="shadow-input animate-fadeInUp animate-animated animate-delay-300 tiptap z-50 mt-4 w-full rounded-3xl rounded-tl-none bg-white p-6 text-lg"
              v-html="question.answer"
            />
            <div
              v-for="(image, key) in question.images"
              :key="image"
              class="shadow-input animate-fadeInUp animate-animated tiptap flex-center z-50 mt-4 flex w-full rounded-3xl rounded-tl-none bg-white p-6 text-lg"
              :style="`animation-delay: ${300 * (key + 2)}ms`"
            >
              <img
                class="shadow-input z-50 max-w-full rounded-xl"
                :src="useImageProxy(image, 1920, 0)"
                alt=""
              >
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.height-enter-active,
.height-leave-active {
  transition: all 0.3s;
}

.height-enter-from,
.height-leave-to {
  transform: translateX(10px);
  opacity: 0
}
</style>

<style>
.tiptap>p>a {
  color: rgba(220, 120, 24);
  text-decoration: underline;
}
</style>
